<template>
  <div class="tab-selector">

    <template v-for="(tab, index) in dataTabs">

      <button class="tab-wrapper text-center"
              @click="val = tab.value"
              type="button"
              :key="'bt-' + index"
              :disabled="tab.disabled">

        <div class="tab"
             :class="{active: tab.value === val}">{{tab.label}}</div>

      </button>

      <div class="vertical-line"
           :class="{hidden: hideLine(tab)}"
           :key="'line-' + index"></div>

    </template>

  </div>
</template>

<script>
    import _ from 'lodash'
    import vModel from '@mixins/v-model'

    export default {
        props: {
            dataTabs: {
                type: Array,
                required: true
            },
        },

        methods: {
            hideLine(tab) {
                const length = this.dataTabs.length

                // hides if it's the last tab
                if (this.dataTabs[length - 1] === tab)
                    return true

                // hides if it's the selected tab
                if (tab.value === this.val)
                    return true

                // hides if it's the previous of the selected tab
                const value = _.findIndex(this.dataTabs, (tab) => {
                    return tab.value === this.val
                })
                if (this.dataTabs.indexOf(tab) === value - 1)
                    return true

                return false
            }
        },

        mounted() {
            if (!this.val)
                this.$emit('input', this.dataTabs[0].value)
        },

        mixins: [vModel]
    }
</script>

<style lang="scss" scoped>
@import "~@variables";

.tab-selector {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: $border-1;
  border-radius: 20px;
  width: 100%;

  .tab-wrapper {
    flex-grow: 1;
    color: $grey-4;
    font-size: 14px;
    margin: -1px;

    .tab {
      padding: 6px 0;
      border-radius: 40px;

      &.active {
        color: $white;
        background-color: $blue-primary;
      }
    }

    &:disabled {
      color: #d4d4d4;
      cursor: not-allowed;
    }
  }
}
</style>
